const {
  DIP_YOUR_LOAN_OPTIONS,
  SOLE_INITIAL_QUESTIONS,
  DIP_PERSONAL_DETAILS,
  DIP_ADDRESS_DETAILS,
  DIP_EMPLOYMENT_DETAILS,
  DIP_ABOUT_THIS_CHECK,
  ROOT,
  YOUR_LOAN_OPTIONS,
  YOUR_PERSONAL_DETAILS,
  YOUR_ADDRESS_DETAILS,
  YOUR_EMPLOYMENT_DETAILS
} = require('constants/paths');

export const existingJourneySteps = [
  {
    id: DIP_YOUR_LOAN_OPTIONS,
    titleText: 'Make your loan your own'
  },
  {
    id: SOLE_INITIAL_QUESTIONS,
    titleText: 'Before you apply'
  },
  {
    id: DIP_PERSONAL_DETAILS,
    titleText: 'About you'
  },
  {
    id: DIP_ADDRESS_DETAILS,
    titleText: 'Your current address'
  },
  {
    id: DIP_EMPLOYMENT_DETAILS,
    titleText: 'Your employment, income and expenses'
  },
  {
    id: DIP_ABOUT_THIS_CHECK,
    titleText: 'About this eligibility check'
  }
];

export const ntbJourneySteps = [
  {
    id: ROOT,
    titleText: 'Have we met before?'
  },
  {
    id: YOUR_LOAN_OPTIONS,
    titleText: 'Make your loan your own'
  },
  {
    id: YOUR_PERSONAL_DETAILS,
    titleText: 'About you'
  },
  {
    id: YOUR_ADDRESS_DETAILS,
    titleText: 'Your current address'
  },
  {
    id: YOUR_EMPLOYMENT_DETAILS,
    titleText: 'Your employment, income and expenses'
  },
  {
    id: DIP_ABOUT_THIS_CHECK,
    titleText: 'About this eligibility check'
  }
];

export const ntbProgressPages = [
  ROOT,
  YOUR_LOAN_OPTIONS,
  YOUR_PERSONAL_DETAILS,
  YOUR_ADDRESS_DETAILS,
  YOUR_EMPLOYMENT_DETAILS,
  DIP_ABOUT_THIS_CHECK
];

export const existingProgressPages = [
  DIP_YOUR_LOAN_OPTIONS,
  SOLE_INITIAL_QUESTIONS,
  DIP_PERSONAL_DETAILS,
  DIP_ADDRESS_DETAILS,
  DIP_EMPLOYMENT_DETAILS,
  DIP_ABOUT_THIS_CHECK
];
